'use client';
import Link from '@eliadmin/core/src/components/link';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { ROUTES } from '@eliadmin/core/src/constants/routes';

export const HeaderTextHaveQuestions = () => {
  return (
    <Link
      href={ROUTES.CONTACT()}
      className={cn('text-base font-bold text-black hover:underline lg:text-lg')}
    >
      Máte otázku? Ozvite sa nám!
    </Link>
  );
};
